// extracted by mini-css-extract-plugin
module.exports = {"panel":"booking-panel-module--panel--3BoIT","body":"booking-panel-module--body--3nzyp","form":"booking-panel-module--form--33Grg"};